module.exports = __webpack_public_path__ + "img/horizontal_7_6_pp3_2.77a3a712.png";